import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SouscriptionErrorComponent } from './souscription-error.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorDialogService {
  private opened = false;

  constructor(private dialog: MatDialog) {}

  openDialog(title?: string, desc?: string): void {
    if (!this.opened) {
      this.opened = true;
      const dialogRef = this.dialog.open(SouscriptionErrorComponent, {
        data: {
          description: desc,
          title: title,
        },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.opened = false;
      });
    }
  }
}
